import { RumGlobal } from '@datadog/browser-rum';
import { ILogger } from '@remento/logger';
import { waitForPromise } from '@remento/web-utils/dom/initialization';

import { BrowserAnalyticsReplayConfig } from './@types.js';

export async function initializeReplay(
  logger: ILogger,
  userId: string,
  config: BrowserAnalyticsReplayConfig,
): Promise<RumGlobal | undefined> {
  const ddLogger = logger.extend('replay');
  if (config.sessionSampleRate != null && Math.random() * 100 > config.sessionSampleRate) {
    ddLogger.info('SESSION_IGNORED');
    return;
  }
  ddLogger.info('SESSION_START', () => ({ config }));
  window.DD_RUM = { q: [] };
  const $head = document.querySelector('head') as HTMLHeadElement;
  const $script = document.createElement('script');
  $script.async = true;
  $script.src = 'https://www.datadoghq-browser-agent.com/us5/v5/datadog-rum.js';
  $head.appendChild($script);
  return waitForPromise(
    new Promise((resolve) => {
      window.DD_RUM.q.push(() => {
        window.DD_RUM.init?.(config);
        resolve(window.DD_RUM as unknown as RumGlobal);
      });
    }),
    5000,
  );
}
